// removed by extract-text-webpack-plugin
module.exports = {"modal":"Modales__modal___ZXNV6","selectCliente":"Modales__selectCliente___Ydhi_","bloquearUsuario_footer":"Modales__bloquearUsuario_footer___pqO6t","cambiarContrasena_footer":"Modales__cambiarContrasena_footer___b1jfY","editarUsuario_footer":"Modales__editarUsuario_footer___3Dbuc","btn-50-perc":"Modales__btn-50-perc___2OI2C","form__control-label":"Modales__form__control-label___1zmC3","form__error-message":"Modales__form__error-message___AQkZ5","warning-custom":"Modales__warning-custom___3FA5M"};


//////////////////
// WEBPACK FOOTER
// ./frontEnd/api/reportes/Modales.css
// module id = 1152
// module chunks = 0